/**
 * 商品品牌Mock数据 - 李宁主题
 */

import { delay } from '@/utils/common';
import type { BrandItem, BrandListParams } from '@/api/modules/brand';

// 模拟李宁及相关运动品牌数据
const mockBrands: BrandItem[] = [
  {
    id: '1',
    brandCode: 'LI_NING',
    brandName: '李宁',
    brandNameEn: 'Li-Ning',
    logo: 'https://img.alicdn.com/tfs/TB1cKKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国体育品牌，由体操王子李宁创立，专注于体育用品的设计、研发、制造和销售。',
    website: 'https://www.lining.com',
    sort: 1,
    status: 'enabled',
    isHot: true,
    createTime: '2024-01-10 09:00:00',
    updateTime: '2024-01-15 14:30:00',
  },
  {
    id: '2',
    brandCode: 'ANTA',
    brandName: '安踏',
    brandNameEn: 'ANTA',
    logo: 'https://img.alicdn.com/tfs/TB1jJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国领先的体育用品品牌，专注于为消费者提供专业的体育用品。',
    website: 'https://www.anta.com',
    sort: 2,
    status: 'enabled',
    isHot: true,
    createTime: '2024-01-10 09:05:00',
    updateTime: '2024-01-15 14:25:00',
  },
  {
    id: '3',
    brandCode: 'PEAK',
    brandName: '匹克',
    brandNameEn: 'PEAK',
    logo: 'https://img.alicdn.com/tfs/TB1kJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国知名运动品牌，专注于篮球装备和专业运动产品。',
    website: 'https://www.peaksport.com',
    sort: 3,
    status: 'enabled',
    isHot: true,
    createTime: '2024-01-10 09:10:00',
    updateTime: '2024-01-15 14:20:00',
  },
  {
    id: '4',
    brandCode: 'XTEP',
    brandName: '特步',
    brandNameEn: 'XTEP',
    logo: 'https://img.alicdn.com/tfs/TB1lJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国时尚运动品牌，以"时尚运动"为品牌定位。',
    website: 'https://www.xtep.com',
    sort: 4,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:15:00',
    updateTime: '2024-01-15 14:15:00',
  },
  {
    id: '5',
    brandCode: 'ERKE',
    brandName: '鸿星尔克',
    brandNameEn: 'ERKE',
    logo: 'https://img.alicdn.com/tfs/TB1mJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国运动品牌，致力于将阳光的生活方式传递给世界每一个角落的年轻人。',
    website: 'https://www.erke.com',
    sort: 5,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:20:00',
    updateTime: '2024-01-15 14:10:00',
  },
  {
    id: '6',
    brandCode: 'QIAODAN',
    brandName: '乔丹体育',
    brandNameEn: 'Qiaodan',
    logo: 'https://img.alicdn.com/tfs/TB1nJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国体育用品品牌，专注于运动鞋服的设计与销售。',
    website: 'https://www.qiaodan.com',
    sort: 6,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:25:00',
    updateTime: '2024-01-15 14:05:00',
  },
  {
    id: '7',
    brandCode: 'DEERWAY',
    brandName: '德尔惠',
    brandNameEn: 'Deerway',
    logo: 'https://img.alicdn.com/tfs/TB1oJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国运动休闲品牌，专注于运动休闲产品的开发。',
    website: 'https://www.deerway.com',
    sort: 7,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:30:00',
    updateTime: '2024-01-15 14:00:00',
  },
  {
    id: '8',
    brandCode: 'WARRIOR',
    brandName: '回力',
    brandNameEn: 'Warrior',
    logo: 'https://img.alicdn.com/tfs/TB1pJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国经典运动品牌，具有悠久历史的国民运动鞋品牌。',
    website: 'https://www.warrior.com',
    sort: 8,
    status: 'enabled',
    isHot: true,
    createTime: '2024-01-10 09:35:00',
    updateTime: '2024-01-15 13:55:00',
  },
  {
    id: '9',
    brandCode: 'FEIYUE',
    brandName: '飞跃',
    brandNameEn: 'Feiyue',
    logo: 'https://img.alicdn.com/tfs/TB1qJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国经典帆布鞋品牌，以其简约设计和舒适性著称。',
    website: 'https://www.feiyue.com',
    sort: 9,
    status: 'disabled',
    isHot: false,
    createTime: '2024-01-10 09:40:00',
    updateTime: '2024-01-15 13:50:00',
  },
  {
    id: '10',
    brandCode: 'DOUBLE_STAR',
    brandName: '双星',
    brandNameEn: 'Double Star',
    logo: 'https://img.alicdn.com/tfs/TB1rJKyaRr0gK0jSZFnXXbRRXXa-200-200.png',
    description: '中国知名体育用品品牌，专注于运动鞋和运动装备。',
    website: 'https://www.doublestar.com',
    sort: 10,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:45:00',
    updateTime: '2024-01-15 13:45:00',
  },
  {
    id: '11',
    brandCode: 'MIZUNO',
    brandName: '美津浓',
    brandNameEn: 'Mizuno',
    description: '日本运动品牌，专注于高尔夫、棒球、跑步等专业运动装备。',
    website: 'https://www.mizuno.com',
    sort: 11,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:50:00',
    updateTime: '2024-01-15 13:40:00',
  },
  {
    id: '12',
    brandCode: 'ASICS',
    brandName: '亚瑟士',
    brandNameEn: 'ASICS',
    description: '日本运动品牌，以专业跑步鞋和运动技术著称。',
    website: 'https://www.asics.com',
    sort: 12,
    status: 'enabled',
    isHot: false,
    createTime: '2024-01-10 09:55:00',
    updateTime: '2024-01-15 13:35:00',
  },
];

// Mock API函数
export const brandMockApi = {
  // 获取品牌列表
  getBrandList: async (params: BrandListParams = {}): Promise<{
    data: BrandItem[];
    total: number;
  }> => {
    await delay(300);
    
    let filteredData = [...mockBrands];
    
    // 筛选条件
    if (params.brandName) {
      filteredData = filteredData.filter(item =>
        item.brandName.toLowerCase().includes(params.brandName!.toLowerCase()) ||
        (item.brandNameEn && item.brandNameEn.toLowerCase().includes(params.brandName!.toLowerCase()))
      );
    }
    
    if (params.brandCode) {
      filteredData = filteredData.filter(item =>
        item.brandCode.toLowerCase().includes(params.brandCode!.toLowerCase())
      );
    }
    
    if (params.status) {
      filteredData = filteredData.filter(item => item.status === params.status);
    }
    
    if (params.isHot !== undefined) {
      filteredData = filteredData.filter(item => item.isHot === params.isHot);
    }
    
    // 排序（按sort字段）
    filteredData.sort((a, b) => a.sort - b.sort);
    
    // 分页
    const page = params.page || 1;
    const perPage = params.per_page || 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    
    return {
      data: filteredData.slice(start, end),
      total: filteredData.length,
    };
  },

  // 获取品牌详情
  getBrandById: async (id: string): Promise<{ data: BrandItem }> => {
    await delay(200);
    const brand = mockBrands.find(item => item.id === id);
    if (!brand) {
      throw new Error('品牌不存在');
    }
    return { data: brand };
  },

  // 创建品牌
  createBrand: async (data: any): Promise<{ data: BrandItem }> => {
    await delay(800);
    const newBrand: BrandItem = {
      id: Date.now().toString(),
      ...data,
      createTime: new Date().toLocaleString(),
      updateTime: new Date().toLocaleString(),
    };
    mockBrands.push(newBrand);
    return { data: newBrand };
  },

  // 更新品牌
  updateBrand: async (id: string, data: any): Promise<{ data: BrandItem }> => {
    await delay(600);
    const index = mockBrands.findIndex(item => item.id === id);
    if (index === -1) {
      throw new Error('品牌不存在');
    }
    const updatedBrand = {
      ...mockBrands[index],
      ...data,
      updateTime: new Date().toLocaleString(),
    };
    mockBrands[index] = updatedBrand;
    return { data: updatedBrand };
  },

  // 删除品牌
  deleteBrand: async (id: string): Promise<{ success: boolean }> => {
    await delay(500);
    const index = mockBrands.findIndex(item => item.id === id);
    if (index === -1) {
      throw new Error('品牌不存在');
    }
    mockBrands.splice(index, 1);
    return { success: true };
  },

  // 批量删除品牌
  batchDeleteBrands: async (ids: string[]): Promise<{ success: boolean }> => {
    await delay(800);
    ids.forEach(id => {
      const index = mockBrands.findIndex(item => item.id === id);
      if (index !== -1) {
        mockBrands.splice(index, 1);
      }
    });
    return { success: true };
  },

  // 更新品牌状态
  updateBrandStatus: async (id: string, status: 'enabled' | 'disabled'): Promise<{ success: boolean }> => {
    await delay(400);
    const brand = mockBrands.find(item => item.id === id);
    if (!brand) {
      throw new Error('品牌不存在');
    }
    brand.status = status;
    brand.updateTime = new Date().toLocaleString();
    return { success: true };
  },

  // 更新品牌热门状态
  updateBrandHotStatus: async (id: string, isHot: boolean): Promise<{ success: boolean }> => {
    await delay(400);
    const brand = mockBrands.find(item => item.id === id);
    if (!brand) {
      throw new Error('品牌不存在');
    }
    brand.isHot = isHot;
    brand.updateTime = new Date().toLocaleString();
    return { success: true };
  },

  // 获取品牌选项
  getBrandOptions: async (): Promise<{ data: Array<{ label: string; value: string; logo?: string }> }> => {
    await delay(200);
    const options = mockBrands
      .filter(item => item.status === 'enabled')
      .sort((a, b) => a.sort - b.sort)
      .map(item => ({
        label: item.brandName,
        value: item.id,
        logo: item.logo,
      }));
    return { data: options };
  },

  // 获取热门品牌
  getHotBrands: async (): Promise<{ data: BrandItem[] }> => {
    await delay(200);
    const hotBrands = mockBrands
      .filter(item => item.isHot && item.status === 'enabled')
      .sort((a, b) => a.sort - b.sort);
    return { data: hotBrands };
  },
};

// 导出兼容的 brandMockData 对象，用于 mockApi.ts
export const brandMockData = {
  getBrandOptions: async () => {
    const result = await brandMockApi.getBrandOptions();
    return result.data;
  },

  getBrandList: async (params: BrandListParams = {}) => {
    const result = await brandMockApi.getBrandList(params);
    return {
      list: result.data,
      total: result.total,
      page: params.page || 1,
      per_page: params.per_page || 10,
    };
  },

  getBrandDetail: async (id: string) => {
    const result = await brandMockApi.getBrandById(id);
    return result.data;
  },

  createBrand: async (data: any) => {
    const result = await brandMockApi.createBrand(data);
    return result.data;
  },

  updateBrand: async (id: string, data: any) => {
    const result = await brandMockApi.updateBrand(id, data);
    return result.data;
  },

  deleteBrand: async (id: string) => {
    const result = await brandMockApi.deleteBrand(id);
    return result.success;
  },
};

// 默认导出
export default brandMockApi;